import * as React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import { Typography } from '@material-ui/core';
// import { placeHolderImage } from '../../common/image';

const styles = theme => ({
    error: {
        padding: theme.spacing(2),
        border: theme.borders.dim,
        background: theme.palette.grey[50],
        color: theme.palette.grey[500],
        wordBreak: 'break-word',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
});

class Image extends React.Component {
    state = {
        fileNotFound: false,
        loaded: false,
    }

    componentDidUpdate(prevProps) {
        if (prevProps.src !== this.props.src) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                fileNotFound: false,
                loaded: false,
            });
        }
    }

    onImageNotFound = (e) => {
        e.target.onerror = null;
        // e.target.src = placeHolderImage;
        this.setState({ fileNotFound: true });
    }

    onImageLoaded = () => {
        this.setState({ loaded: true });
    }

    render() {
        const {
            classes, translate, className, src, alt, hideOnNotFound,
        } = this.props;

        if (this.state.fileNotFound) {
            return hideOnNotFound ? null : (
                <div className={classnames(classes.error, className)} title={src}>
                    <Typography align="center" display="block">
                        {translate('common.fileNotFound')}
                    </Typography>
                    {/* <Typography color="textSecondary" align="center" variant="caption" display="block">
                        {`(${src})`}
                    </Typography> */}
                </div>
            );
        }

        const style = { opacity: this.state.loaded ? 1 : 0, transition: 'opacity 0.1s' };

        return (
            <img
                src={src}
                alt={alt}
                style={style}
                className={className}
                onError={this.onImageNotFound}
                onLoad={this.onImageLoaded}
            />
        );
    }
}

Image.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    src: PropTypes.string,
    alt: PropTypes.string,
    className: PropTypes.string,
    hideOnNotFound: PropTypes.bool,
};

Image.defaultProps = {
    src: '',
    alt: '',
    className: null,
    hideOnNotFound: false,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(Image));
